<template>
  <span class="fts-json-pretty">
    <template v-if="dataType === 'Object'">
      <span class="js-tree-brackets" @click="collapse=!collapse" v-if="collapse">{ ... }</span>
      <template v-else>
        <span class="js-tree-brackets" @click="collapse=!collapse">{</span>
          <div class="indent" v-for="(val, key) in data" :key="`${key}-${uid}`">
            <span class="js-comment" v-if="isComment(key)">{{ val }}</span>
            <template v-else>
              <span>"{{ key }}"</span> : <fts-json-pretty :data="val" />
            </template>
          </div>
        <span class="js-tree-brackets" @click="collapse=!collapse">}</span>
      </template>
    </template>
    <template v-else-if="dataType === 'Array'">
      <span class="js-tree-brackets" @click="collapse=!collapse" v-if="collapse">[ ... ]</span>
      <template v-else>
        <span class="js-tree-brackets" @click="collapse=!collapse">[</span>
          <div class="indent" v-for="(x, index) in data" :key="`${index}-${uid}`">
            <fts-json-pretty :data="x" />
          </div>
        <span class="js-tree-brackets" @click="collapse=!collapse">]</span>
      </template>
    </template>
    <span class="js-value js-value--null" v-else-if="dataType === 'Null'">
      null
    </span>
    <span class="js-value js-value--undefined" v-else-if="dataType === 'Undefined'">
      undefined
    </span>
    <span class="js-value js-value--number" v-else-if="dataType === 'Number'">
      {{ data }}
    </span>
    <span class="js-value js-value--boolean" v-else-if="dataType === 'Boolean'">
      {{ data }}
    </span>
    <span class="js-value js-value--string" v-else>
      "{{ data }}"
    </span>
  </span>
</template>

<script>
export default {
  name: "fts-json-pretty",
  props: {
    data: [Array, Object, String, Number, Boolean],
    defaultCollapse: Boolean
  },
  data: () => ({
    uid: null,
    collapse: false,
  }),
  methods: {
    isComment(key) {
      return key && key.startsWith('//') && key.endsWith('_comment');
    }
  },
  computed: {
    dataType() {
      if (Object.prototype.toString.call(this.data) === "[object Array]")
        return "Array";
      else if (Object.prototype.toString.call(this.data) === "[object Object]")
        return "Object";
      else if (Object.prototype.toString.call(this.data) === "[object Number]")
        return "Number";
      else if (Object.prototype.toString.call(this.data) === "[object Boolean]")
        return "Boolean";
      else if (Object.prototype.toString.call(this.data) === "[object Null]")
        return "Null";
      else if (Object.prototype.toString.call(this.data) === "[object Undefined]")
        return "Undefined";
      else
        return "String";
    }
  },
  mounted() {
    this.uid = this._uid;
    this.defaultCollapse && (this.collapse = true);
  }
}
</script>

<style lang="scss" scoped>
.indent {
  padding-left: 1rem;
}
.js-tree-brackets {
  cursor: pointer;
  &:hover {
    color: var(--fts-primary);
  }
}
.js-comment {
  color: #2e7d32;
}
.js-value {
  word-break: break-word;
  &.js-value--number,
  &.js-value--boolean {
    color: #1d8ce0;
  }
  &.js-value--string {
    color: #13ce66;
  }
  &.js-value--null,
  &.js-value--undefined {
    color: #d55fde;
  }
}
</style>